import { connect } from 'react-redux';
import OrderTransaction from '../components/exchange/OrderTransaction';
import actions from '../redux/actions/order_transaction';
import orderBookActions from '../redux/actions/orderbook';

const mapStateToProps = (state) => ({
  orderTransactions: state.orderTrans.orderTransactions,
});

const mapDispatchToProps = (dispatch) => ({
  onfetchAllOrderTransactionAction: (params) => {
    dispatch(actions.fetchAllOrderTransactionAction(params));
  },
  onClickOrderBookBuy: (params) => {
    dispatch(orderBookActions.clickOrderBookBuy(params));
  },
  onClickOrderBookSell: (params) => {
    dispatch(orderBookActions.clickOrderBookSell(params));
  },
});

export const OrderTransactionContainer = connect(mapStateToProps, mapDispatchToProps)(OrderTransaction);
